import React, { Suspense, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  ChatLink,
  SpinnerComponent,
  StickyHeaderVds3,
} from "common/components";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { useSelector, useDispatch } from "react-redux";
import IncompatiblePackageModal from "common/components/ProductDetails/modals/IncompatiblePackageModal";
import {
  addToCart,
  setIsByodZipcode,
  setDeviceListBy,
  setFetchCartByodUpdated,
  setCarrierDetailsByDevice,
  setShowByodDqNotify,
  replaceDeviceForExceedingcreditLimitNew,
  setAddToCartDisble,
  setPlansFirstDevices,
  setPlansFirstAllDevices,
} from "pages/Mobility/ducks/MobilitySlice";
import get from "lodash/get";
import uniqBy from "lodash/uniqBy";
import cloneDeep from "lodash/cloneDeep";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { FLOWS, setShowSimCompatible } from "app/ducks/GlobalSlice";
import * as SiteAnalytics from "sitecatalyst";
import * as SiteAnalyticsVZDL from "../../../src/sitecatalyst/VZDLSiteCatalyst.js"
import { useGlobalData } from "hooks";
import {
  MarginSpacerL,
  MarginSpacerM,
  MarginSpacerS,
  MarginSpacerXL,
  MarginSpacer3XL,
  MarginSpacer2XL,
  MarginSpacer
} from "common/components/styleTag";
import { Button, TextLink, TextLinkCaret } from "@vds/buttons";
import { Grid, Row, Col } from "@vds/grids";
import { Line } from "@vds/lines";
// import { Notification } from "@vds/notifications";
// import { TileContainer } from "@vds/tiles";
import {
  // Button,
  // TextLink,
  // Grid,
  // Row,
  // Col,
  // Line,
  Notification,
  // Body,
  // Title,
  Text,
  TitleLockup, TitleLockupSubtitle, TitleLockupTitle,
  TileContainer,
  Modal
} from "@vds/core";
import { Icon } from "@vds/icons";
import PromoHeader from "./components/PromoHeader/PromoHeader";
import PromoBanner from "../../common/components/PromoBannerVDS3/PromoBannerVDS3";
import ZipCodeModal from "../../common/components/ZipCodeModal/ZipCodeModal";
import NewCustomerModal from "../../common/components/Modals/NewCustomerModal";
import MaximumDevicesModal from "../../common/components/ProductDetails/modals/MaximumDevicesModal";
import GetDeviceDetailsModal from "./getDeviceDetails";
import RemoveModalByod from "./RemoveModalByod";
import SEOTagger from "common/components/SEOTagger/SEOTagger";
import NewCustomerAddressModal from "common/components/Modals/NewCustomerAddressModal";
import {
  DeviceInfoContainer,
  LeftImageSection,
  RowNoPad,
  ColNoPad,
  ButtonContainer,
} from "./components/DeviceTile/styles";
import ByodPackageImage from "./components/ByodPackageImage/ByodPackageImage";
import { getDescriptionInfo, getDeviceName } from "utils/ItemDescription";
import { getRetrieveCart5G } from "pages/Checkout/ducks/CheckoutSlice";
import GridwallPlansFirstDevices from "pages/Mobility/components/MobilityGridwall/GridwallPlansFirstDevices";
import StepContainer from "./components/StepContainer/StepContainer";
import {
  setLinesCount,
  setLinesRemain,
  setLinesUpdatedForByod,
} from "pages/PlanFirst/ducks/PlanFirstSlice";
import PlansFirstDevicesApplyModal from "common/components/ProductDetails/modals/PlansFirstDevicesApplyModal";
import ProtectionLegalDetails from "common/components/ProtectionPlans/ProtectionLegalDetails";
import Header from "./Header";
import { VZStepper } from "common/components/HorizontalProgress/VZStepper";
import DeviceTile from "./components/DeviceTile/DeviceTile";
import {
  getMultiSimPayload,
  getInitialDeviceState,
  getByodDeviceList,
} from "./utils";
import DeviceTileMonarch from "./components/DeviceTile/DeviceTileMonarch";
import { ProductBoxWrapMonarch, TextOnImageWrapper, TextOnImage } from "common/components/DeviceCard/styles";
import { Tilelet } from "@vds/tiles";
import { ImageTile, ImageTileProps } from '@vbg-ds/core';
import PlansOverview from './PlansOverview';

const ByodMonarch = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const sourceParam = searchParams.get("source");
  const fromLearn = searchParams.get("from");
  const isFromLearn = fromLearn === "byodLearn" ? true : false;
  const { metaInformation, allGlobalPromos } = useGlobalData({
    skipSessionCart: !isFromLearn,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const pathUrl = location?.pathname;
  const isMobileDevice = useMediaQuery({
    query: "(max-width: 767px)",
  });
  const targetRef = useRef();
  const scrollToTarget = () => {
    if (isMobileDevice) {
      targetRef?.current?.scrollIntoView({ behaviour: "smooth" });
    }
  };
  const globalData = useSelector((state) => state.GlobalData);
  const pageData = useSelector((state) => state.MobilityPage);
  const plansFirstPageData = useSelector((state) => state.PlanFirst);
  const pageDataInfo = useSelector((state) => state.CheckoutPage);
  const lqPageData = useSelector((state) => state.LQPage);
  const landing4gData = useSelector((state) => state.Landing4GPage);
  const zipCodeFromLearn = useSelector((state) => {
    return (
      state.PlanFirst?.addressFromLearn?.zipCode ??
      state.PlanFirst?.addressFromLearn?.zipCodeVal
    );
  });
  const { t, ready } = useTranslation(["app", "byod"], {
    useSuspense: false,
  });
  const newAddressModalPopUp =
    window?.mbtGlobal?.flags?.ENABLE_FCC_BROADBAND_FACTS === "Y" ? true : false;
  const availZip = pageData?.confirmZipcode != "" ? true : false;
  const showZipcodeModal = metaInformation?.showZipCodeModal && !availZip;
  const isPDPProtectionEnabled = metaInformation?.showProtectionFeaturesOnPDP;
  const [zipCode, setZipcode] = useState(pageData?.zipCode);
  const [navigateToPlans, setNavigateToPlans] = useState(false);
  const [showIncompatibleModal, setIncompatibleModal] = useState(false);

  const [isDq, setIsDq] = useState(false)

  const [showIMEINotificationOuter, setShowIMEINotificationOuter] = useState(false)
  const [showIncompatibleNotificationOuter, setShowIncompatibleNotificationOuter] = useState(false)

  const [checkProtection, setCheckProtection] = useState(false)
  const [isFeatureError, setFeatureError] = useState(false);

  const [showBlackOffer, setShowBlackOffer] = useState(true);
  const pdpBillingAddress = {
    addressLine1: lqPageData?.address?.place?.properties?.street,
    city: lqPageData?.address?.place?.properties?.city,
    state: lqPageData?.address?.place?.properties?.state,
    zipCode: lqPageData?.address?.place?.properties?.postalCode,
    zipPlus4: lqPageData?.address?.place?.properties?.zipPlus4,
    unit: lqPageData?.unit?.unit,
  };

  const pageError = get(pageData, "apiError", false);
  const isMobile = useMediaQuery({
    query: "(max-width:767px)",
  });
  const isLaptop = useMediaQuery({
    query: "(min-device-width: 1024px)",
  });
  const isDesktop = useMediaQuery({
    query: "(min-device-width: 1200px)",
  });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 });
  const isPortrait = useMediaQuery({ orientation: "portrait" });
  const aemContent = t("byod", { ns: "byod", returnObjects: true });
  const aemContentMonarch = t("byodMonarch", { ns: "byod", returnObjects: true });
  const showLearnEditPage = t("byod.showLearnEditPage", { ns: "byod" });
  const enableLaptopPromo = t("byod.enableLaptopPromo", { ns: "byod" });
  const enableTabletPromo = t("byod.enableTabletPromo", { ns: "byod" });
  const byodFromLearnCheck = t("byod.byodFromLearnCheck", { ns: "byod" });
  const enableByodSteps = t("byod.enableBYODSteps", { ns: "byod" });

  const promoData =
    window?.location?.pathname?.includes("laptops") && enableLaptopPromo === "Y"
      ? allGlobalPromos?.byod?.laptopPage
      : window?.location?.pathname?.includes("tablets") &&
        enableTabletPromo === "Y"
        ? allGlobalPromos?.byod?.tabletPage
        : allGlobalPromos?.byod?.page || null;
  const [isContinueButtonClicked, setIsContinueButtonClicked] = useState(false);
  const isLaptopByod = window?.location?.pathname?.includes("laptops");
  const isTabletByod = window?.location?.pathname?.includes("tablets");

  const deviceListBy = pageData?.deviceListBy ?? [getInitialDeviceState()];
  const fetchCartByodUpdated = pageData?.fetchCartByodUpdated;
  const showByodDqNotify = pageData?.showByodDqNotify;
  const [deviceList, setDeviceList] = useState(uniqBy(deviceListBy, "id"));
  const [completedCount, setCompletedCount] = useState(0);
  const [byodList, setByodDeviceList] = useState([]);
  const [byodAgentList, setByodAgentDeviceList] = useState([]);
  const [showNewCustomerModal, setShowNewCustomerModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [deviceDetailsModal, setDeviceDetailsModal] = useState(false);
  const [removeDevice, setRemoveDevice] = useState(null);
  const [removeLearnDevice, setRemoveLearnDevice] = useState(null);
  const [isNonByod, setIsNonByod] = useState(false);
  const [addMoreDevice, setAddMoreDevice] = useState(false);
  const [isAddMoreDisabled, setIsAddMoreDisabled] = useState(false);
  const editPackagePackageId = globalData?.editPackagePackageId;
  const isEditPackageFlow = globalData?.isEditPackageFlow;
  const isAddMoreByodPackage = globalData?.isAddMoreByodPackage;
  const [showMaxDeviceModal, setMaxDeviceModal] = useState(false);
  const [gotoDeviceReivew, setDeviceReview] = useState(false);
  const [showByod, setShowByod] = useState(false);
  const [showByodPage, setShowByodPage] = useState(false);
  const [showDeviceConfirmModal, setShowDeviceConfirmModal] = useState(false);
  const sessionCartData =
    globalData?.sessionCartData?.apiResponse?.prospectFlowData;
  const maxDeviceQuantity = 10;
  const max_field = 9;
  const packObj = sessionCartData?.cart?.packages ?? "";
  const isHeaderInfo = Object.keys(packObj).length > 0 ? true : false;
  const isPlansFirstFlow =
    sourceParam === "device-selection" ||
    globalData?.flow === FLOWS.PLANFIRST ||
    plansFirstPageData?.isByodDevice;
  const isPlansFirst = globalData?.flow === "plans-first";
  const newMixedCartPlanFirstFlow =
    globalData?.newMixedCartPlanFirstFlow || false;
  const goToCart = () => navigate("/shop/shopping-cart");
  const [selectedDeviceId, setSelectedDeviceId] = useState("");
  const [protectionAddedOnByod, setProtectionAddedOnByod] = useState(0);
  const [queryString] = useSearchParams();
  const queryParams = Object.fromEntries([...queryString]);
  const goToPlans = () => {
    if (globalData?.flow === FLOWS.PLANFIRST) {
      navigate("/shop/products/plans");
    } else navigate("/shop/plans");
  };
  const isPlansFirstNew = globalData?.flow === "plans-first";
  const plansFirstCategories = t("plans-first.category", {
    ns: "app",
    returnObjects: true,
  });
  const [nonPFDevicesExists, setNonPFDevicesExists] = useState(false);
  const [remainingLines, setRemainingLines] = useState(
    plansFirstPageData?.linesRemain
  );
  const [isNonSmartphone, setAddedNonSmartphone] = useState(false);
  const [isZipcodeOnContinue, setIsZipcodeOnContinue] = useState(false);
  const movePDPAddressModaltoGW = globalData?.metaInformation?.addressModalOnGW;
  const selected5GPlans = useSelector(
    (state) => state.Landing5GPage.primaryPlan.selectedPlan
  );
  const selected4GPlans = useSelector(
    (state) => state.Landing4GPage.primaryPlan.selectedPlan
  );
  const featureList = useSelector(
    (state) => state.MobilityPage?.PDPFeatureList
  );
  const [isConnectedDevices, setIsConnectedDevices] = useState(false);
  const [showLegalDetails, setShowLegalDetails] = useState(false);
  const isAgentLink =
    globalData?.isAgentlink && sessionCartData?.fromAgentLinkPage;
  const [readOfferModal, setReadOfferModal] = useState(false)
  const [readOfferModalBlackBanner, setReadOfferModalBlackBanner] = useState(false)

  useEffect(() => {
    if (
      ready &&
      window?.newrelic &&
      window?.newrelic?.interaction &&
      !navigator.userAgent.match("CriOS")
    ) {
      window?.newrelic?.interaction().end();
    }
  }, [ready]);
  useEffect(() => {
    if (globalData?.metaInformation?.showNewBYODPage) {
      const Universal_AB_Test = new CustomEvent("Universal_AB_Test", {
        eventName: "Universal_AB_Test",
        eventPayload: { testId: "bounteous|BYOD_new_experience" },
      });
      digitalData.events.push({
        eventName: "Universal_AB_Test",
        eventPayload: { testId: "bounteous|BYOD_new_experience" },
      });
    }
  }, [globalData?.metaInformation?.showNewBYODPage]);

  useEffect(()=>{
    if(showIMEINotificationOuter){
      SiteAnalytics.errorEncounter({ "data": aemContentMonarch?.deviceTile?.invalidIMEITitle+"."+aemContentMonarch?.deviceTile?.invalidIMEISubTitle, "id": showIMEINotificationOuter, "title": aemContentMonarch?.deviceTile?.invalidIMEITitle+"."+aemContentMonarch?.deviceTile?.invalidIMEISubTitle, "subtitle": aemContentMonarch?.deviceTile?.invalidIMEISubTitle });
    }
    else if(showNotification){
      SiteAnalytics.errorEncounter({ "data": "Please provide details about your device to continue", "id": showNotification, "title": "Please provide details about your device to continue", "subtitle": "" });
    }
  },[showIMEINotificationOuter,showNotification])

  useEffect(() => {
    setZipcode(pageData?.zipCode);
  }, [pageData?.zipCode]);

  useEffect(() => {
    try {
      window.sessionStorage.setItem("_flowName", "Byod");
      if (
        typeof window["lpTag"] != "undefined" &&
        lpTag?.section &&
        window?.lpTag?.newPage
      ) {
        lpTag.section = manipulateLpTagSections();
        setTimeout(() => {
          window?.lpTag?.newPage(window?.location?.href, {
            section: lpTag.section,
          });
        }, 10000);
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    const count = deviceList.filter((d) => d.completed).length;
    setCompletedCount(count);
    const haveFeature = deviceList.filter(
      (d) =>
        d?.selectedFeature &&
        !d?.selectedFeature?.displayName?.includes("Decline")
    ).length;
    setProtectionAddedOnByod(haveFeature);
  }, [deviceList]);

  useEffect(() => {
    const { flowId } = queryParams;
    if (flowId !== undefined && flowId !== null) {
      const payload = {
        sourcePath: "extAddCart",
        flowId: flowId,
        flow: "5G",
      };
      dispatch(getRetrieveCart5G(payload));
    }
  }, []);

  useEffect(() => {
    if (sessionCartData?.cart?.packages && showLearnEditPage) {
      const sessionResponse = sessionCartData?.cart?.packages;
      let haveByodFromLearn = false;

      if (sessionResponse && Object.keys(sessionResponse || {})?.length) {
        for (let key in sessionResponse) {
          if (
            sessionResponse.hasOwnProperty(key) &&
            sessionResponse[key]?.byod === true &&
            sessionResponse[key]?.fromLearn === true
          ) {
            haveByodFromLearn = true;
          }
        }
      }

      if (
        sessionResponse &&
        Object.keys(sessionResponse)?.length &&
        ((byodFromLearnCheck == "Y" && haveByodFromLearn) || isFromLearn)
      ) {
        let updatedList = [];
        const byodDevice = getByodDeviceList({ cartPackages: sessionResponse });
        const data = byodDevice && byodDevice?.length > 0 ? byodDevice[0] : {};
        if (data) {
          updatedList.push(data);
        }
        if (updatedList && updatedList?.length > 0) {
          setByodDeviceList(updatedList);
        }
      }
    }
  }, [sessionCartData, isFromLearn]);

  useEffect(() => {
    if (sessionCartData?.cart?.packages && isAgentLink) {
      const sessionResponse = sessionCartData?.cart?.packages;

      if (sessionResponse && Object.keys(sessionResponse)?.length) {
        let updatedList = getByodDeviceList({
          cartPackages: sessionResponse,
          isAgentLink,
        });
        if (sessionCartData?.cart?.packages) {
          const sessionPkgIds = Object.keys(sessionCartData?.cart?.packages);
          updatedList = updatedList
            .filter((d) => sessionPkgIds.includes(d?.packageId))
            .map((d) => {
              const cartPkg = sessionCartData?.cart?.packages?.[d?.packageId];
              const updatedPkg = { ...d };
              if (cartPkg) {
                const cartFeature = Object.values(cartPkg?.features ?? {}).find(
                  (i) => i?.type === "SFO"
                );
                updatedPkg.selectedFeature = {
                  displayName: cartFeature?.featureDesc,
                  featureCode: cartFeature?.visFeatureCode,
                  featureType: cartFeature?.type,
                  featureLevel: cartFeature?.level,
                  quantity: "1",
                };
              }
              return updatedPkg;
            });
        }

        if (updatedList && updatedList?.length > 0) {
          setByodAgentDeviceList(updatedList);
        }
      }
    }
    if (sessionCartData?.cart?.digitalQuote) {
      setIsDq(true)
    }
  }, [sessionCartData]);

  useEffect(() => {
    if (
      isFromLearn === true &&
      deviceList &&
      deviceList?.length === 1 &&
      addMoreDevice
    ) {
      handleAddMoreDevices();
    }
  }, [isFromLearn, addMoreDevice]);

  useEffect(() => {
    let deviceListDeepClone = cloneDeep(deviceList);
    const updatedDeviceList = deviceListDeepClone?.map((device) => {
      return { ...device, updated: false };
    });

    if (
      (!!isEditPackageFlow && !!editPackagePackageId) ||
      !!isAddMoreByodPackage
    ) {
      const data = { isEditable: true, completed: false };
      let updatedList = updatedDeviceList?.map((device) => {
        if (
          editPackagePackageId?.includes(device?.packageId) ||
          editPackagePackageId === device?.packageId
        ) {
          return { ...device, ...data };
        }
        return device;
      });
      if (sessionCartData?.cart?.packages) {
        const sessionPkgIds = Object.keys(sessionCartData?.cart?.packages);
        updatedList = updatedList
          .filter((d) => sessionPkgIds.includes(d.packageId))
          .map((d) => {
            const cartPkg = sessionCartData?.cart?.packages?.[d?.packageId];
            const updatedPkg = { ...d };
            if (cartPkg) {
              const cartFeature = Object.values(cartPkg?.features ?? {}).find(
                (i) => i?.type === "SFO"
              );
              updatedPkg.selectedFeature = {
                displayName: cartFeature?.featureDesc,
                featureCode: cartFeature?.visFeatureCode,
                featureType: cartFeature?.type,
                featureLevel: cartFeature?.level,
                quantity: "1",
              };
            }
            return updatedPkg;
          });
      }
      if ((updatedList?.length == 0 || (updatedList?.length == 1 && !updatedList[0]?.deviceInfo))) {
        const byodDevice = getByodDeviceList({ cartPackages: sessionCartData?.cart?.packages });
        const data = byodDevice && byodDevice?.length > 0 ? byodDevice[0] : {};
        if (data) {
          updatedList.push(data);
        }
      }
      if (updatedList?.length) {
        setDeviceList(updatedList);
        dispatch(setDeviceListBy(updatedList));
      }
    } else {
      if (
        updatedDeviceList?.length &&
        !pageData?.deviceSelectedForExceedginCreditLimitNew
      ) {
        setDeviceList(updatedDeviceList);
        dispatch(setDeviceListBy(updatedDeviceList));
      }
    }
    SiteAnalytics.trackPageInfo();
    SiteAnalyticsVZDL.trackPageInfoVZDL("Add device","BYOD","Digital Prospect")

  }, [sessionCartData]);

  useEffect(() => {
    if (sessionCartData?.cart?.packages) {
      const packages = sessionCartData?.cart?.packages;
      for (const pkg in packages) {
        const pkgObj = packages[pkg];
        if (!pkgObj.byod) {
          setIsNonByod(true);
        }
      }
    }
  }, [sessionCartData]);

  useEffect(() => {
    if (pageError) {
      navigate("/shop/contact-us", {
        state: { refUrl: window.location.pathname },
      });
    }
  }, [pageError]);

  useEffect(() => {
    if (
      pageDataInfo?.fetchCart &&
      Object.keys(pageDataInfo?.fetchCart)?.length &&
      !fetchCartByodUpdated &&
      sessionCartData?.cart?.packages
    ) {
      const packages = sessionCartData?.cart?.packages;
      const updatedDeviceList = [];
      for (const pkg in packages) {
        const pkgObj = packages[pkg];
        const isSmartphone =
          pkgObj &&
          pkgObj.deviceCategory?.toLowerCase()?.includes("Smartphone");
        const msg = isSmartphone ? "Smartphone" : "Laptop";
        if (pkgObj?.emptyByodFromDQ) {
          updatedDeviceList.push({
            ...getInitialDeviceState(),
            isDQ: true,
            message: pkgObj?.productName ?? msg,
            packageId: pkg,
            isEditable: !!(editPackagePackageId === pkg) && !isEditPackageFlow,
          });
        }
      }
      if (
        updatedDeviceList?.length &&
        !pageData?.deviceSelectedForExceedginCreditLimitNew
      ) {
        setDeviceList(updatedDeviceList);
        dispatch(setDeviceListBy(updatedDeviceList));
        dispatch(setFetchCartByodUpdated(true));
        dispatch(setShowByodDqNotify(true));
      }
    }
  }, [pageDataInfo?.fetchCart?.cart]);

  useEffect(() => {
    const { flowId } = queryParams;
    if (flowId !== undefined && flowId !== null) {
      const packages = sessionCartData?.cart?.packages;
      const updatedDeviceList = [];
      for (const pkg in packages) {
        const pkgObj = packages[pkg];
        const isSmartphone =
          pkgObj &&
          pkgObj.deviceCategory?.toLowerCase()?.includes("Smartphone");
        const msg = isSmartphone ? "Smartphone" : "Laptop";
        if (pkgObj?.emptyByodFromDQ) {
          updatedDeviceList.push({
            ...getInitialDeviceState(),
            isDQ: true,
            message: pkgObj?.productName ?? msg,
            packageId: pkg,
            isEditable: !!(editPackagePackageId === pkg) && !isEditPackageFlow,
          });
        } else {
          for (i in deviceList) {
            if (deviceList[i].packageId?.includes(pkg)) {
              updatedDeviceList.push(deviceList[i]);
            }
          }
        }
      }
      if (
        updatedDeviceList?.length &&
        !pageData?.deviceSelectedForExceedginCreditLimitNew
      ) {
        setDeviceList(updatedDeviceList);
        dispatch(setDeviceListBy(updatedDeviceList));
        dispatch(setFetchCartByodUpdated(true));
        dispatch(setShowByodDqNotify(true));
      }
    }
  }, [sessionCartData]);

  useEffect(() => {
    if (
      pageData?.addToCartResponse?.status?.statusCode === 200 &&
      isContinueButtonClicked
    ) {
      const sessionResponse =
        pageData?.addToCartResponse?.response?.cart?.packages;
      if (sessionResponse && Object.keys(sessionResponse)?.length) {
        const byodDevice = Object.keys(sessionResponse).map((key) => {
          const pack = sessionResponse?.[key];
          if (pack?.byod && pack?.deviceSku && !pack?.byor) {
            return {
              deviceSku: pack?.deviceSku,
              packageId: key,
              carrier: pack?.carrierData,
              imei: pack?.imei,
            };
          }
        });
        let deviceListDeepClone = cloneDeep(deviceList);
        const updatedDeviceList = deviceListDeepClone?.map((device) => {
          let devices;
          SiteAnalytics.eventAddtocartTracking(
            "Add To Cart",
            device,
            "BYOD",
            "prospect"
          );
          byodDevice?.forEach((key) => {
            if (
              key?.deviceSku === device?.deviceInfo?.deviceSkuId &&
              key?.imei === device?.imei
            ) {
              devices = { packageId: key?.packageId };
            } else if (
              key?.deviceSku === device?.selectedDevice?.sku &&
              key?.carrier === device?.selectedCarrier &&
              !key?.imei
            ) {
              devices = { packageId: key?.packageId };
            }
          });
          return { ...device, ...devices };
        });
        setDeviceList(updatedDeviceList);
        dispatch(setDeviceListBy(updatedDeviceList));
      }
      setIsContinueButtonClicked(false);

      if (globalData?.flow === "plans-first") {
        if (!isNonSmartphone) {
          plansFirstDeviceDataUpdate();
        } else {
          plansFirstDeviceDataUpdate();
        }
      } else {
        if (
          pageData?.disableAddToCart ||
          gotoDeviceReivew ||
          (pageData?.deviceSelectedForExceedginCreditLimitNew !== null &&
            pageData?.deviceSelectedForExceedginCreditLimitNew &&
            pageData?.deviceSelectedForExceedginCreditLimitNew.length)
        ) {
          if (navigateToPlans) navigate("/shop/plans");
          else navigate("/shop/products/devices/device-review-new");
        } else {
          if (!newMixedCartPlanFirstFlow) {
            isPlansFirstFlow
              ? navigate("/shop/products/plans")
              : dispatch(setIsByodZipcode(true));

            if (pageData?.addToCartResponse?.response) {
              let packages =
                pageData?.addToCartResponse?.response?.cart?.packages;
              let isAllConnectedDevices =
                Object.keys(packages)?.length ==
                Object.keys(packages)?.filter((key) =>
                  packages[key]?.deviceCategory?.includes("Connected Devices")
                )?.length;
              isAllConnectedDevices ? goToCart() : goToPlans();
            } else {
              isConnectedDevices ? goToCart() : goToPlans();
            }
          } else if (
            newMixedCartPlanFirstFlow &&
            (sessionCartData?.cart?.mixedCartApplied?.includes("REGULAR_4G") ||
              sessionCartData?.cart?.mixedCartApplied?.includes("REGULAR_5G"))
          ) {
            navigate("/shop/plans");
          } else {
            if (isPlansFirstFlow && !isPDPProtectionEnabled) {
              navigate("/shop/features");
            } else if (isPlansFirstFlow && isPDPProtectionEnabled) {
              navigate("/shop/shopping-cart");
            } else {
              navigate("/shop/plans");
            }
          }
        }
      }
    } else if (
      pageData?.addToCartResponse?.status?.statusMessage ===
      "PACKAGE_INCOMPATIBLE"
    ) {
      setIncompatibleModal(true);
    }
  }, [pageData?.addToCartResponse]);

  const plansFirstDeviceDataUpdate = () => {
    if (
      globalData?.flow === "plans-first" &&
      plansFirstPageData?.linesRemain > 0
    ) {
      const addToCartResponse = pageData?.addToCartResponse;
      const packages = addToCartResponse?.response?.cart?.packages;
      const packageIds = Object.keys(packages).filter(
        (key, _line) =>
          !key.toUpperCase()?.includes("LINE") && packages[key]?.lineId
      );
      const linePackageIds = Object.keys(packages).filter((key, _line) =>
        key.toUpperCase()?.includes("LINE")
      );

      let deviceIdsForDeleteAction = {};
      let d = 0;
      linePackageIds?.length > 0 &&
        linePackageIds.forEach((id) => {
          const device = packages[id];
          const deviceDetails = {
            packageId: id,
            packageType: device?.packageType,
            lineId: device?.lineId,
            lineIndex: device?.lineId?.substring(
              device.lineId.indexOf("_") + 1
            ),
            isByod: device?.byod,
          };
          deviceIdsForDeleteAction[d++] = deviceDetails;
        });
      packageIds?.length > 0 &&
        packageIds.forEach((id) => {
          const device = packages[id];
          const deviceDetails = {
            packageId: id,
            packageType: device?.packageType,
            lineId: device?.lineId,
            lineIndex: device?.lineId?.substring(
              device.lineId.indexOf("_") + 1
            ),
            isByod: device?.byod,
          };
          deviceIdsForDeleteAction[d++] = deviceDetails;
        });

      let newSelected = {};
      let i = 0;
      packageIds.forEach((id) => {
        const device = packages[id];
        let img = device.imageSet.substring(
          0,
          device.imageSet.indexOf("?req=set,json") > 0
            ? device.imageSet.indexOf("?req=set,json")
            : device.imageSet.length
        );

        const deviceDetails = {
          deviceName: device.packageDesc,
          image: img,
          packageId: id,
          packageType: device?.packageType,
          lineId: device?.lineId,
          deviceSku: device?.deviceSku,
          deviceId: device?.deviceId,
          lineIndex: device?.lineId?.substring(device.lineId.indexOf("_") + 1),
          isByod: device?.byod,
          capacity: device?.capacity,
          color: device?.color,
        };
        newSelected[i++] = deviceDetails;
      });
      let linesRemain =
        plansFirstPageData?.linesCount - Object.keys(newSelected).length;
      if (linesRemain < 1) {
        linesRemain = linesRemain < 1 ? 0 : linesRemain;
        dispatch(setLinesCount(Object.keys(newSelected).length));
      }
      setRemainingLines(linesRemain);
      dispatch(setLinesRemain(linesRemain));
      dispatch(setPlansFirstDevices(newSelected));
      dispatch(setPlansFirstAllDevices(deviceIdsForDeleteAction));
      plansFirstRedirection(linesRemain);
    } else {
      plansFirstRedirection(plansFirstPageData?.linesRemain);
    }
  };

  const plansFirstRedirection = (linesRemain) => {
    if (
      (linesRemain === 0 || plansFirstPageData?.linesRemain === 0) &&
      !nonPFDevicesExists &&
      !isPDPProtectionEnabled
    ) {
      navigate("/shop/features");
    } else if (
      (linesRemain === 0 || plansFirstPageData?.linesRemain === 0) &&
      !nonPFDevicesExists &&
      isPDPProtectionEnabled
    ) {
      navigate("/shop/shopping-cart");
    } else if (
      (linesRemain === 0 || plansFirstPageData?.linesRemain === 0) &&
      nonPFDevicesExists
    ) {
      navigate("/shop/plans");
    } else {
      navigate("/shop/products/devices/smartphones");
    }
  };

  useEffect(() => {
    if (
      (globalData?.flow === "plans-first" &&
        pageData?.deviceListBy &&
        plansFirstPageData?.linesRemain > 0) ||
      plansFirstPageData.linesUpdatedForByod
    ) {
      let plansFirstByodDevices = pageData?.deviceListBy?.filter((device) => {
        if (
          plansFirstCategories?.includes(device?.deviceName) &&
          device?.deviceName.toLowerCase().includes("smartphone")
        ) {
          if (
            device?.deviceInfo?.category?.toLowerCase().includes("smartphone")
          ) {
            return true;
          } else if (Object.keys(device?.deviceInfo || {}).length === 0) {
            return true;
          } else {
            return false;
          }
        } else {
          setNonPFDevicesExists(true);
        }
        return false;
      });

      let updateList = [];
      const selected = pageData?.plansFirstDevices ?? {};
      let newSelected = { ...selected };
      let byodIndex = 0;
      let j = 0;
      if (Object.keys(newSelected || {}).length > 0) {
        Object.entries(newSelected || {}).forEach(([key, value]) => {
          if (value?.byodId || value.isByod) {
            let byodDevice = Object.entries(plansFirstByodDevices || {}).filter(
              ([bk, bv]) =>
                bv?.id === value?.byodId ||
                (value?.packageId && bv.packageId === value.packageId)
            );

            if (byodDevice?.length > 0) {
              updateList[j++] = value;
              byodIndex++;
            }
          } else {
            updateList[j++] = value;
          }
        });
      } else {
        let i = 0;
        Object.entries(plansFirstByodDevices || {}).forEach(([key, device]) => {
          if (device?.selectedDevice || device?.imei) {
            const deviceDetails = updatePFList(device);
            updateList[i++] = deviceDetails;
          }
        });
      }

      if (
        byodIndex !== Object.keys(plansFirstByodDevices || {}).length &&
        Object.keys(newSelected || {}).length > 0
      ) {
        let currentIndex = Object.keys(updateList || {}).length;
        console.log(
          byodIndex,
          " = ",
          plansFirstByodDevices,
          "  == ",
          updateList,
          " == ",
          newSelected
        );
        Array.from({
          length: Object.keys(plansFirstByodDevices || {}).length - byodIndex,
        })
          .fill(1)
          .map((item, index) => {
            let device = plansFirstByodDevices[index + byodIndex];
            if (
              plansFirstCategories?.includes(device?.deviceName) &&
              (device?.selectedDevice || device?.imei)
            ) {
              const deviceDetails = updatePFList(device);
              updateList[currentIndex++] = deviceDetails;
            }
          });
      }

      dispatch(setPlansFirstDevices(updateList));
    } else if (plansFirstPageData?.linesRemain < 1) {
      setNonPFDevicesExists(true);
    }

    if (plansFirstPageData?.linesUpdatedForByod) {
      dispatch(setLinesUpdatedForByod(false));
    }
  }, [pageData?.deviceListBy, plansFirstPageData?.linesUpdatedForByod]);

  const updatePFList = (device) => {
    let deviceDetails = {};
    if (Object.keys(device?.deviceInfo || {}).length > 0) {
      deviceDetails = {
        deviceName:
          device?.deviceInfo?.brandName + " " + device?.deviceInfo?.name,
        image: device?.deviceInfo?.imageSet,
        packageId: device?.deviceInfo?.deviceSkuId,
        byodId: device?.id,
      };
    } else {
      deviceDetails = {
        deviceName: device?.selectedDevice
          ? device?.selectedDevice?.make +
          " " +
          device?.selectedDevice?.modelName
          : device?.deviceName,
        image: device?.selectedDevice?.imageName,
        packageId: device?.selectedDevice?.sku,
        byodId: device?.id,
      };
    }
    return deviceDetails;
  };

  const handleDeviceUpdate = (data, id) => {
    let deviceListDeepClone = cloneDeep(deviceList);
    const updatedDeviceList = deviceListDeepClone.map((device) => {
      if (device.id === id) {
        return { ...device, ...data };
      }
      return device;
    });
    setDeviceList(updatedDeviceList);
    dispatch(setDeviceListBy(updatedDeviceList));
  };
  const handleDeviceUpdateAgent = (data, id) => {
    let deviceListDeepClone = cloneDeep(byodAgentList);
    const updatedDeviceList = deviceListDeepClone.map((device) => {
      if (device.id === id) {
        return { ...device, ...data };
      }
      return device;
    });
    setByodAgentDeviceList(updatedDeviceList);
    dispatch(setDeviceListBy(updatedDeviceList));
  };

  const handleMultiDeviceUpdate = (devList) => {
    setDeviceList(devList);
    dispatch(setDeviceListBy(devList));
  };

  const handleDeviceId = (id) => {
    setSelectedDeviceId(id);
  };
  const newCustomerBtnClicked = (zipCodeVal) => {
    if (zipCodeVal) {
      finalizeMultipleSimSelection(zipCodeVal);
    } else {
      finalizeMultipleSimSelection();
    }
  };
  const SelectedBYODDevice = ({ selectedDevice }) => {
    const deviceInformation = {
      brand: selectedDevice?.deviceName,
      imageSet: selectedDevice?.imageSet,
    };
    return (
      <LeftImageSection>
        <div>
          <ByodPackageImage
            device={deviceInformation}
            description={{}}
            deviceList={{}}
            width={72}
            height={72}
          />
        </div>
        <DeviceInfoContainer>
          <Grid
            colSizes={{ mobile: 2, tablet: 12, desktop: 12 }}
            colGutter={false}
          >
            <RowNoPad>
              <ColNoPad colSizes={{ mobile: 2, tablet: 12, desktop: 12 }}>
                <Text kind="title" bold size="medium" className="info">
                  {selectedDevice?.deviceName
                    ? selectedDevice?.deviceName
                    : selectedDevice?.productName}
                </Text>
              </ColNoPad>
            </RowNoPad>
          </Grid>
          {selectedDevice?.selectedCarrier && (
            <>
              <MarginSpacerM />
              <Text kind="body" size="small" color="#6F7171">
                {t("byod.skipImei.carrier", { ns: "byod" })}
              </Text>
              {selectedDevice?.selectedCarrier}
            </>
          )}
          {selectedDevice?.imei && (
            <>
              <MarginSpacerM />
              <Text kind="body" size="small" color="#6F7171">
                {t("byod.byod-collection.completedTile.deviceLabelCredit", {
                  ns: "byod",
                })}
              </Text>
              {selectedDevice?.imei}
              <MarginSpacerM />
              <Text kind="body" size="small" color="#747676">
                {t("byod.tradeIn.enterSimIdNew", { ns: "byod" })}
              </Text>
              {!selectedDevice?.newSim
                ? t("byod.byod-collection.completedTile.embeddedSim", {
                  ns: "byod",
                })
                : t("byod.byod-collection.completedTile.newCard", {
                  ns: "byod",
                })}
            </>
          )}
          <MarginSpacerM />
          <Text kind="body" size="small" color="#747676">
            {t("byod.skipImei.phoneNumber", { ns: "byod" })}
          </Text>
          <div className="sectest">
            {selectedDevice?.portIn
              ? t("byod.skipImei.newPhoneNumber", { ns: "byod" })
              : t("byod.skipImei.existingPhoneNumber", { ns: "byod" })}
          </div>
        </DeviceInfoContainer>
      </LeftImageSection>
    );
  };
  const existingCustomerBtnClicked = () => {
    let redirectUrl = `${t("pdpDeepLinkUrl", { ns: "app" })}`;
    window.location.href = redirectUrl;
  };

  const handleRemove = (id) => {
    const selectedDeviceList = deviceList.filter((device) => device.id === id);
    if (
      selectedDeviceList.length > 0 &&
      (selectedDeviceList[0]?.imei ||
        selectedDeviceList[0]?.selectedCarrier ||
        selectedDeviceList[0]?.isDQ)
    ) {
      setRemoveDevice(id);
      // removeByodDevice(id);
    }
    else if (selectedDeviceList.length == 1) {
      setRemoveDevice(id);
    }
    else {
      removeByodDevice(id);
    }
  };

  const addMoreDeviceDisable = (devices) => {
    let value = true;
    const activeDevice = Array.isArray(devices) && devices[devices.length - 1];
    value = activeDevice?.completed ? false : true;
    return value;
  };

  const removeByodDevice = (id) => {
    const updatedDeviceList = deviceList.filter((device) => device.id !== id);
    const requiredDeviceList = deviceList.filter((device) => device.id === id);
    setDeviceList(updatedDeviceList);
    dispatch(setDeviceListBy(updatedDeviceList));
    setRemoveDevice(null);
    if (requiredDeviceList?.length && requiredDeviceList?.[0]?.packageId) {
      let payload = {
        cartMeta: {
          zipCode,
          shoppingPath: "prospect",
          approach: isPlansFirstNew ? "plans-first" : "",
        },
        lines: [
          {
            packageId: requiredDeviceList?.[0]?.packageId || "",
            packageType: "REGULAR",
            operation: "DELETE",
            quantity: 1,
          },
        ],
      };
      if (isPlansFirstNew) {
        payload?.lines?.push({
          packageId: "",
          packageType: "REGULAR",
          operation: "ADD",
          quantity: 1,
        });
      }
      dispatch(addToCart(payload));
    }
  };

  const removeByodLearnDevice = (id) => {
    setRemoveLearnDevice(null);
    if (byodList?.length && byodList?.[0]?.packageId === id) {
      let payload = {
        cartMeta: {
          zipCode,
          shoppingPath: "prospect",
          approach: isPlansFirstNew ? "plans-first" : "",
        },
        lines: [
          {
            packageId: id || "",
            packageType: "REGULAR",
            operation: "DELETE",
            quantity: 1,
          },
        ],
      };
      dispatch(addToCart(payload));
      setByodDeviceList([]);
    }
  };

  const handleAddMoreDevices = () => {
    const allPackagesObj = sessionCartData?.cart?.packages;
    let packagesExcludeBYOD = Object.values(allPackagesObj ?? {})?.filter(
      (pack) => !pack.byod
    );
    let packagesObj = [];
    if (globalData?.flow === "plans-first") {
      let packagesNotDummy = Object.values(packagesExcludeBYOD || {})?.filter(
        (key, line) => !key.lineId.toUpperCase().includes("LINE_")
      );
      Object.keys(packagesNotDummy || {}).forEach(
        (key, line) => (packagesObj[key] = packagesExcludeBYOD[key])
      );
    } else {
      packagesObj = packagesExcludeBYOD;
    }
    if (
      pageData?.deviceSelectedForExceedginCreditLimitNew !== null &&
      pageData?.deviceSelectedForExceedginCreditLimitNew &&
      pageData?.deviceSelectedForExceedginCreditLimitNew?.length
    ) {
      if (
        (packagesObj &&
          Object.keys(packagesObj)?.length -
          pageData?.deviceSelectedForExceedginCreditLimitNew?.length +
          deviceList.length >=
          max_field) ||
        deviceList.length >= max_field
      ) {
        setMaxDeviceModal(true);
      } else {
        const updatedDeviceList = [...deviceList, getInitialDeviceState()];
        setDeviceList(updatedDeviceList);
        dispatch(setDeviceListBy(updatedDeviceList));
        dispatch(setCarrierDetailsByDevice(null));
      }
    } else {
      if (
        (packagesObj &&
          Object.keys(packagesObj).length + deviceList.length >= max_field) ||
        deviceList.length >= max_field
      ) {
        setMaxDeviceModal(true);
      } else {
        const updatedDeviceList = [...deviceList, getInitialDeviceState()];
        setDeviceList(updatedDeviceList);
        dispatch(setDeviceListBy(updatedDeviceList));
        dispatch(setCarrierDetailsByDevice(null));
      }
    }
  };

  const finalizeMultipleSimSelection = (zipCodeVal = "") => {
    setIsContinueButtonClicked(true);
    const planFirstPackages = new Set();
    if (isPlansFirstFlow) {
      plansFirstPageData?.clickedLineId &&
        planFirstPackages.add(plansFirstPageData?.clickedLineId);
      Object.entries(globalData?.sessionCartData?.devices || {})
        ?.filter(([_key, line]) => line?.deviceFullDetail?.dummy)
        ?.forEach(([key, _line]) => planFirstPackages.add(key));
    }
    const selectedDeviceList = isAgentLink
      ? cloneDeep(byodAgentList)
      : cloneDeep(deviceList);
    const packageIds = [Object.keys(pageData?.plansFirstAllDevices).length];
    Object.entries(pageData?.plansFirstAllDevices || {}).forEach(
      ([key, device], index) => {
        packageIds[index] = device?.packageId;
      }
    );

    const payload = getMultiSimPayload({
      devices: selectedDeviceList,
      zipCode: zipCodeVal
        ? zipCodeVal
        : zipCode
          ? zipCode
          : lqPageData?.address?.place?.properties?.postalCode,
      pdpBillingAddress,
      isEmptyByodFromDQFlow: globalData?.isEmptyByodFromDQFlow,
      isEditPackageFlow,
      editPackagePackageId,
      isAddMoreByodPackage,
      planFirstPackages: packageIds?.length > 0 ? packageIds : [],
      flow: globalData?.flow,
      plansFirstCategories,
      planId: plansFirstPageData?.plansFirstData?.planId,
      isAgentLink,
    });

    for (let line of payload.lines) {
      if (
        line?.packageId === "" &&
        line?.device?.deviceCategory?.toLowerCase() !== "smartphones"
      ) {
        setAddedNonSmartphone(true);
      }
    }

    let skipPlanFor15gifts;
    let pkgIds;
    if (globalData?.sessionCartData?.apiResponse) {
      let pkgIds = Object.keys(
        globalData?.sessionCartData?.apiResponse?.prospectFlowData?.cart
          ?.packages ?? {}
      );
      let pkgs =
        globalData?.sessionCartData?.apiResponse?.prospectFlowData?.cart
          ?.packages;
      let is15gifts = String(
        globalData?.sessionCartData?.apiResponse?.prospectFlowData?.cart?.origin
      )
        .toUpperCase()
        .includes("15GIFTS");
      let smartPhoneList = payload?.lines?.filter(
        (key) =>
          !String(key?.device?.deviceCategory)
            .toLowerCase()
            .includes("smartphone")
      );
      const isSmartphone = smartPhoneList?.length ? false : true;

      let skipPlanFor15gifts = pkgIds?.filter(
        (key) =>
          !!pkgs?.[key]?.plan?.pricePlanDesc &&
          is15gifts &&
          pkgs?.[key]?.emptyByodFromDQ
      );
      if (
        skipPlanFor15gifts?.length === pkgIds?.length &&
        pkgIds?.length === deviceList?.length &&
        isSmartphone
      ) {
        payload.routeToFeatures = "features";
      }
    }
    if (
      t("4G-5G.newJointOfferBundleFlow.isNewJOFlowEnabled", { ns: "4G-5G" }) &&
      !!payload?.lines &&
      payload?.lines.length &&
      landing4gData?.joRegularLineData != null
    ) {
      let linesForPayload = [...payload?.lines];
      linesForPayload.map((line) => {
        line["plan"] = { planId: landing4gData?.joRegularLineData };
        if (landing4gData?.joMyBizAddons) {
          line.features = [
            ...(line?.features || []),
            ...landing4gData?.joMyBizAddons,
          ];
        }
        return line;
      });
      payload["lines"] = [...linesForPayload];
    }
    if (isEditPackageFlow && !payload?.lines?.length) {
      if (sessionCartData?.cart?.packages) {
        let packages = sessionCartData?.cart?.packages;
        const sessionPkgIds = Object.keys(sessionCartData?.cart?.packages);
        let sessionWithNoPlan = sessionPkgIds?.filter(
          (key) =>
            !!packages?.[key]?.byod &&
            !packages?.[key]?.byor &&
            (!packages?.[key]?.plan || !packages?.[key]?.features)
        );
        if (sessionWithNoPlan?.length) {
          if (skipPlanFor15gifts?.length === pkgIds?.length) {
            navigate("/shop/features");
          } else {
            navigate("/shop/plans");
          }
        } else {
          navigate("/shop/shopping-cart");
        }
      }
    } else if (!payload?.lines?.length) {
      globalData?.flow === "plans-first"
        ? plansFirstRedirection()
        : isConnectedDevices
          ? goToCart()
          : goToPlans();
    } else {
      if (
        pageData?.deviceSelectedForExceedginCreditLimit !== null &&
        pageData?.deviceSelectedForExceedginCreditLimit &&
        sessionCartData !== null &&
        sessionCartData &&
        (pageData?.deviceSelectedForExceedginCreditLimitNew === null ||
          pageData?.deviceSelectedForExceedginCreditLimitNew === undefined)
      ) {
        const { cart } = sessionCartData;
        if (
          cart?.packages &&
          cart?.packages[pageData?.deviceSelectedForExceedginCreditLimit] !==
          null &&
          cart?.packages[pageData?.deviceSelectedForExceedginCreditLimit]
        ) {
          payload.lines.map((line) => {
            line["operation"] = "ADD";
          });
          payload.lines.push({
            packageId: pageData?.deviceSelectedForExceedginCreditLimit,
            packageType: "REGULAR",
            operation: "DELETE",
          });
          payload.exceedingCreditLimitData =
            payload.lines[0]["device"]["deviceSku"];
        }
      }
      if (
        pageData?.deviceSelectedForExceedginCreditLimitNew !== null &&
        pageData?.deviceSelectedForExceedginCreditLimitNew
      ) {
        payload.exceedingCreditLimitData = [];
        pageData?.deviceSelectedForExceedginCreditLimitNew.map((device, i) => {
          const getCategory = String(device.deviceCategory)
            .toLowerCase()
            .includes(
              String(
                payload["lines"][i]["device"]["deviceCategory"]
              ).toLowerCase()
            )
            ? true
            : false;
          if (!getCategory) setNavigateToPlans(true);
          const feature = Object.values(device["features"]).find(
            (feat) => feat["type"] === "SFO"
          );
          payload["lines"][i]["features"] = [];
          if (getCategory)
            payload["lines"][i]["plan"] = {
              planId: device["plan"]["pricePlanCode"],
              promoEligible: false,
            };
          payload["lines"][i]["features"].push({
            featureCode: feature["visFeatureCode"],
            featureLevel: feature["level"],
            featureType: feature["type"],
            operation: "ADD",
            quantity: "1",
          });
          payload.exceedingCreditLimitData.push(
            payload.lines[i]?.device?.deviceSku
          );
          payload.lines.push({
            packageId: device["packageId"],
            packageType: "REGULAR",
            operation: "DELETE",
          });
        });
        dispatch(replaceDeviceForExceedingcreditLimitNew([]));
        setDeviceReview(true);
        dispatch(setAddToCartDisble(true));
      }
      // if adding multi-device protection, apply to all lines
      if (sessionCartData?.cart?.packages) {
        console.log("Add TMP-MD to cart packages");
        const mdFeature = selectedDeviceList?.find((i) =>
          i?.selectedFeature?.displayName?.includes(
            "Total Mobile Protection Multi-Device"
          )
        )?.selectedFeature;
        if (!!mdFeature) {
          const TMPMDLineCount = payload.lines?.filter(
            (l) =>
              l.features &&
              l.features?.[0]?.displayName?.includes("Total Mobile Protection")
          )?.length;
          if (TMPMDLineCount !== payload.lines?.length) {
            const featureTMPMD = payload.lines?.filter(
              (l) =>
                l.features &&
                l.features?.[0]?.displayName?.includes(
                  "Total Mobile Protection"
                )
            )?.[0];
            payload.lines?.forEach(
              (l) => (l.features = featureTMPMD?.features)
            );
          }

          for (const [id, pack] of Object.entries(
            sessionCartData?.cart?.packages
          )) {
            if (
              !pack?.deviceCategory?.toLowerCase()?.includes("laptop") &&
              !id?.includes("LINE")
            ) {
              const updatePkg = {
                packageId: id,
                packageType: pack?.packageType,
                operation: "UPDATE",
                features: [],
              };
              const featureToDelete = Object.values(pack?.features ?? {}).find(
                (feat) => feat?.type === "SFO"
              );
              updatePkg.features.push({
                operation: "DELETE",
                featureCode: featureToDelete?.visFeatureCode,
                featureType: featureToDelete?.type,
                featureLevel: featureToDelete?.level,
                quantity: "1",
              });
              updatePkg.features.push({
                operation: "ADD",
                ...mdFeature,
              });
              payload.lines.push(updatePkg);
            }
          }
        }
      }

      dispatch(addToCart(payload));
      dispatch(setCarrierDetailsByDevice(null));
      dispatch(setShowSimCompatible(true));
    }
  };

  const increaseLinesCount = () => {
    dispatch(setLinesCount(plansFirstPageData?.linesCount + 1));
    dispatch(setLinesUpdatedForByod(true));
  };

  const checkFlowForModal = () => {
    if (
      globalData?.flow === "plans-first" &&
      pageData?.plansFirstDevices?.length >= plansFirstPageData?.linesCount
    ) {
      setShowDeviceConfirmModal(true);
    } else {
      setCheckProtection(false)
      handleAddMoreDevices();
    }
  };

  const onClickImeifinalizeMultipleSimSelection = () => {
    const packagesObj = sessionCartData?.cart?.packages;

    if (isAgentLink) {
      const deviceData =
        byodAgentList?.filter((d) => d?.completed).length <
        byodAgentList?.length;
      if (
        (packagesObj && Object.keys(packagesObj).length > max_field) ||
        byodAgentList.length > max_field
      ) {
        setMaxDeviceModal(true);
        return;
      } else if (packagesObj && deviceData) {
        navigate("/shop/shopping-cart");
      } else if (
        (!!pageData?.zipcodeFromGW ||
          !!pageData?.zipCode ||
          !!zipCodeFromLearn) &&
        movePDPAddressModaltoGW
      ) {
        if (pageData?.zipcodeFromGW) {
          newCustomerBtnClicked();
        } else {
          setIsZipcodeOnContinue(true);
          setShowNewCustomerModal(true);
        }
      } else {
        let zipVal = !!pageData?.zipcodeFromGW
          ? !!pageData?.zipcodeFromGW
          : !!pageData?.zipCode
            ? !!pageData?.zipCode
            : !!zipCodeFromLearn
              ? !!zipCodeFromLearn
              : false;
        setIsZipcodeOnContinue(zipVal);
        setShowNewCustomerModal(true);
      }
    } else {
      const deviceData =
        deviceList?.filter((d) => d?.completed).length < deviceList?.length;
      if (
        (packagesObj && Object.keys(packagesObj).length > max_field) ||
        deviceList.length > max_field
      ) {
        setMaxDeviceModal(true);
        return;
      } else if (packagesObj && deviceData) {
        navigate("/shop/shopping-cart");
      } else if (packagesObj && !isFromLearn) {
        newCustomerBtnClicked();
      } else if (
        (!!pageData?.zipcodeFromGW ||
          !!pageData?.zipCode ||
          !!zipCodeFromLearn) &&
        movePDPAddressModaltoGW
      ) {
        if (pageData?.zipcodeFromGW) {
          newCustomerBtnClicked();
        } else {
          setIsZipcodeOnContinue(true);
          setShowNewCustomerModal(true);
        }
      } else {
        let zipVal = !!pageData?.zipcodeFromGW
          ? !!pageData?.zipcodeFromGW
          : !!pageData?.zipCode
            ? !!pageData?.zipCode
            : !!zipCodeFromLearn
              ? !!zipCodeFromLearn
              : false;
        setIsZipcodeOnContinue(zipVal);
        setShowNewCustomerModal(true);
      }
    }
  };

  const onClickShowNotificationbar = (showNotification) => {
    setShowNotification(false);
    if (disabled()) {
      if (checkProtection) {
        setFeatureError(true)
      } else {
        setShowNotification(true);
        window.scrollTo(0, 0)
      }
    } else if (deviceList?.some(d => d?.isByor)) {
      let learnUrlLower = `${t("learnUrlLower", { ns: "app" })}`;
      let learnUrlProd = `${t("learnUrlProd", { ns: "app" })}`;
      if (window.mbtGlobal.reactUibasePath === "/mbt/prospect/") {
        window.location.href = learnUrlLower;
      } else {
        window.location.href = learnUrlProd;
      }
    } else {
      onClickImeifinalizeMultipleSimSelection();
    }
  };

  const disabled = () => {
    let disabled = true;
    if (isAgentLink) {
      let completed = byodAgentList.filter((d) => d.completed).length;
      let editDeviceId = "";
      let isEditable = byodAgentList.filter((d) => {
        editDeviceId = d?.id;
        return (
          d?.isEditable &&
          !d?.completed &&
          !!d?.displayType &&
          d?.selectedDevice &&
          !!Object.keys(d?.selectedDevice)?.length &&
          !!d?.packageId &&
          !!d?.deviceSku &&
          !!d?.selectedCarrier &&
          !!(isPDPProtectionEnabled && Object.keys(d?.selectedFeature)?.length)
        );
      })?.length;
      if (isEditable) {
        const data = {
          completed: true,
        };
        handleDeviceUpdateAgent(data, editDeviceId);
      }
      if (
        pageData?.deviceSelectedForExceedginCreditLimitNew !== null &&
        pageData?.deviceSelectedForExceedginCreditLimitNew &&
        pageData?.deviceSelectedForExceedginCreditLimitNew.length
      ) {
        if (
          completed ===
          pageData?.deviceSelectedForExceedginCreditLimitNew.length
        )
          disabled = false;
      } else disabled = completed + isEditable < byodAgentList.length;
    } else {
      let completed = deviceList.filter((d) => d.completed).length;
      let editDeviceId = "";
      let isEditable = deviceList.filter((d) => {
        editDeviceId = d?.id;
        return (
          d?.isEditable &&
          !d?.completed &&
          !!d?.displayType &&
          d?.selectedDevice &&
          !!Object.keys(d?.selectedDevice)?.length &&
          !!d?.packageId &&
          !!d?.deviceSku &&
          !!d?.selectedCarrier &&
          !!(isPDPProtectionEnabled && Object.keys(d?.selectedFeature)?.length)
        );
      })?.length;
      if (isEditable) {
        const data = {
          completed: true,
        };
        handleDeviceUpdate(data, editDeviceId);
      }
      if (
        pageData?.deviceSelectedForExceedginCreditLimitNew !== null &&
        pageData?.deviceSelectedForExceedginCreditLimitNew &&
        pageData?.deviceSelectedForExceedginCreditLimitNew.length
      ) {
        if (
          completed ===
          pageData?.deviceSelectedForExceedginCreditLimitNew.length
        )
          disabled = false;
      } else disabled = completed + isEditable < deviceList.length;
    }

    return disabled;
  };
  const showMoreDevices = () => {
    let show = true;
    let completed = deviceList.filter((d) => d.completed).length;
    if (
      pageData?.deviceSelectedForExceedginCreditLimitNew !== null &&
      pageData?.deviceSelectedForExceedginCreditLimitNew &&
      pageData?.deviceSelectedForExceedginCreditLimitNew.length
    ) {
      if (
        completed === pageData?.deviceSelectedForExceedginCreditLimitNew.length
      )
        show = false;
    }
    return show;
  };
  const getImageUrl = (url) => {
    if (!(typeof url === "string" && url?.length)) {
      return "";
    } else if (url.charAt(0) === "/") {
      return `${window?.mbtGlobal?.assetsBaseUrl}${url}`;
    } else {
      return url;
    }
  };
  const promotionalCardImage = () => {
    if (pathUrl?.includes('tablets')) {
      return `${aemContentMonarch?.promotionalCard?.tablets?.ss7ImgUrl}`
    }
    else if (pathUrl?.includes('laptops')) {
      return `${aemContentMonarch?.promotionalCard?.laptops?.ss7ImgUrl}`
    }
    else {
      return `${aemContentMonarch?.promotionalCard?.smartPhones?.ss7ImgUrl}`
    }
  }
  const getBlackOfferContent = () => {

    if (pathUrl?.includes('laptops')) {
      return aemContentMonarch?.blackOffers?.smartphonesAndTablets?.content;
    }
    else if (pathUrl?.includes('tablets')) {
      return aemContentMonarch?.blackOffers?.smartphoneAndLaptops?.content;
    }
    else {
      return aemContentMonarch?.blackOffers?.laptopAndTablets?.content;
    }
    //else return setShowBlackOffer(false);
  }
  const promotionalCardTitle = () => {
    if (pathUrl?.includes('tablets')) {
      return aemContentMonarch?.promotionalCard?.tablets?.heading;
    }
    else if (pathUrl?.includes('laptops')) {
      return aemContentMonarch?.promotionalCard?.laptops?.heading;
    }
    else {
      return aemContentMonarch?.promotionalCard?.smartPhones?.heading;
    }
  };

  const promotionalCardSubTitle = () => {
    if (pathUrl?.includes('tablets')) {
      return aemContentMonarch?.promotionalCard?.tablets?.subHeading;
    }
    else if (pathUrl?.includes('laptops')) {
      return aemContentMonarch?.promotionalCard?.laptops?.subHeading;
    }
    else
      return aemContentMonarch?.promotionalCard?.smartPhones?.subHeading;
  }

  const handleReadOfferDetails = () => {
    setReadOfferModal(true)
  }

  const handleReadOfferDetailsBlackBanner = () => {
    setReadOfferModalBlackBanner(true);
  }

  return (
    <>
      {pageData?.loading && <SpinnerComponent />}
      <SEOTagger pageName={"prospect"} />
      <StickyHeaderVds3
        backClickHandler={() => {
          window.history.back();
        }}
        onContinue={onClickShowNotificationbar}
        onCartClick={goToCart}
        enableBackLink={true}
        hideContinueButton={false}
        hideTotals={true}
        hideAddress={true}
        continueBtnText={
          deviceList?.some(d => d?.isByor) ?
            t("byodMonarch.deviceTile.byorContent.checkAvailability", { ns: "byod" }) :
            isPlansFirstNew ||
              (selected5GPlans && Object.keys(selected5GPlans)?.length > 0) ||
              (selected4GPlans && Object.keys(selected4GPlans)?.length > 0)
              ? "Continue"
              : t("byod.continueBtn", { ns: "byod" })
        }
        hideShoppingBagIcon={!isHeaderInfo}
        pdp={true}
        headetitle={<Header count={completedCount} />}
        datatrackValue="Header | Button | Continue to plans"
        pageName={"BYODMonarch"}
      />
      <Grid colSizes={{ mobile: 4, tablet: 12, desktop: 12 }} colGutter={false}>
        <Row>
          <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
            <VZStepper />
          </Col>
        </Row>
        <Row>
          <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
            {showByodDqNotify && (
              <Notification
                kind="information"
                title="Please provide details about your device to continue"
                fullBleed={true}
                onCloseButtonClick={() => dispatch(setShowByodDqNotify(false))}
                opened={showByodDqNotify}
                data-color="Blue"
              />
            )
            }
            {showNotification && (
              <Notification
                kind="error"
                title="Please provide details about your device to continue"
                fullBleed={true}
                onCloseButtonClick={() => setShowNotification(false)}
                opened={showNotification}
              />
            )
            }
          </Col>
        </Row>
      </Grid>
      {showZipcodeModal && !newAddressModalPopUp && (
        <ZipCodeModal pageData={pageData} />
      )}
      {showIncompatibleModal && (
        <IncompatiblePackageModal
          opened={showIncompatibleModal}
          onOpenedChange={setIncompatibleModal}
          sessionCartData={sessionCartData}
          onContinue={() => {
            vbcInCart && dispatch(clear4g5gCart());
            dispatch(clearCartAndAddToCart(addToCartPayload));
          }}
        />
      )}

      <Container>
        <Grid>
          <Row>
            <Col colSizes={{ mobile: 4, tablet: 8, desktop: 8 }}>
              <div style={{ margin: '2px' }}></div>
            </Col>
            <Col
              colSizes={{ mobile: 4, tablet: 4, desktop: 4 }}
              className="chat-link-wrappper byod-chat-link"
            >
              {!isMobile && (
                <>
                  <ChatLink />
                </>
              )}
            </Col>
          </Row>
          <MarginSpacerXL />
          <Row>
            <TitleLockup>
              <TitleLockupTitle size={isMobile ? "titleXLarge" : "title2XLarge"} bold={false}>
                {landing4gData?.fwaBundleTabSelected ?
                  <>  <span style={{ color: "#E10014" }}>{aemContentMonarch?.heroSection?.fwaBYODTitleRed}</span>
                    <span style={{ color: "#000000" }}> {aemContentMonarch?.heroSection?.fwaBYODTitleBlack}</span>
                  </> :
                  <span style={{ color: "#E10014" }}>{aemContentMonarch?.heroSection?.title}</span>}
              </TitleLockupTitle>
              <TitleLockupSubtitle size="titleMedium" bold={false}>
                {landing4gData?.fwaBundleTabSelected ? <span dangerouslySetInnerHTML={{ __html: aemContentMonarch?.heroSection?.fwaBYODsubTitle }}></span>
                  : <span>{aemContentMonarch?.heroSection?.subTitle}</span>
                }
              </TitleLockupSubtitle>
            </TitleLockup>
          </Row>
          <MarginSpacerXL />
          {!landing4gData?.fwaBundleTabSelected ? <Row>
            {aemContentMonarch?.heroSection?.heroIcons &&
              [...aemContentMonarch?.heroSection?.heroIcons]
                .sort((a, b) => (a.position || 0) - (b.position || 0))
                .map((item, index) => {
                  return (
                    <StyledCol
                      lastIndex={(index + 1) === aemContentMonarch?.heroSection?.heroIcons.length}
                      colSizes={{ mobile: 2, tablet: 3, desktop: 2 }}
                      key={index}>
                      <span style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "8px"
                      }}>
                        <Icon
                          name={item.iconName}
                          size="XLarge" color="#E10014"
                        />
                        <div style={{ position: 'relative', top: '3px' }}>
                          <TitleLockupTitle size="titleXSmall">{item?.Title}</TitleLockupTitle>
                        </div>
                      </span>
                    </StyledCol>
                  );
                })}
          </Row> : <></>} 
          {/* {!isMobile && <MarginSpacer2XL />} */}
        </Grid>

        <Suspense fallback={<></>}>
          <Grid
            colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
            gutterWidth="24px"
          >


            <Row>
              <Col>
                <TitleLockup >
                  <MarginSpacer3XL />
                  <MarginSpacer />
                  <TitleLockupTitle size={isMobile ? "titleMedium" : "titleLarge"} bold={false} color="#E10014" >
                    <TitleLockupTitleDiv>
                      {aemContentMonarch?.heroSection?.checkCompatibility}
                    </TitleLockupTitleDiv>
                  </TitleLockupTitle>
                  {isMobile ? <MarginSpacerM /> : <MarginSpacerXL />}
                </TitleLockup>
              </Col>
            </Row>
            <Row>
              <ColNoPad
                colSizes={{ mobile: 4, tablet: 6, desktop: 8 }}>
                <>
                  {showIMEINotificationOuter && <><Notification
                    kind="error"
                    title={aemContentMonarch?.deviceTile?.invalidIMEITitle}
                    bodyText={aemContentMonarch?.deviceTile?.invalidIMEISubTitle}
                    fullBleed={false}
                    showCloseButton={false}
                    buttons={
                      [
                        {
                          kind: "secondary",
                          children: "Shop new devices",
                          onClick: () => navigate("/shop/products/devices/smartphones"), // Navigate to the desired route
                          "data-track": "Device IMEI | IMEI not compatible message | Shop new devices button"
                        },
                      ]
                    }

                    opened={showIMEINotificationOuter}
                  /><MarginSpacerM /></>}
                  {showIncompatibleNotificationOuter && <><Notification
                    kind="error"
                    title={aemContentMonarch?.deviceTile?.notMobilePhoneTitle}
                    bodyText={aemContentMonarch?.deviceTile?.notMobilePhoneSubTitle}
                    fullBleed={false}
                    showCloseButton={false}
                    buttons={
                      [
                        {
                          kind: "secondary",
                          children: "Shop new devices",
                          onClick: () => navigate("/shop/products/devices/smartphones"), // Navigate to the desired route
                        },
                      ]
                    }

                    opened={showIncompatibleNotificationOuter}
                  /><MarginSpacerM /></>}
                </>
                {!showLearnEditPage && byodList && byodList?.length > 0 ? (
                  <TileContainer
                    aspectRatio="none"
                    backgroundColor="#f6f6f6"
                    height="auto"
                    padding={isMobile ? "16px" : "24px"}
                  >
                    <ButtonContainer isMobile={isMobile}>
                      {deviceList?.length > 0 && (
                        <span>
                          <TextLink
                            size={isMobile ? "small" : "medium"}
                            type="standAlone"
                            onClick={(e) =>
                              handleRemoveBYODLearn(byodList[0].packageId)
                            }
                          >
                            {t("byod.byod-collection.remove", { ns: "byod" })}
                          </TextLink>
                        </span>
                      )}
                    </ButtonContainer>
                    <SelectedBYODDevice
                      selectedDevice={byodList[0]}
                    ></SelectedBYODDevice>
                  </TileContainer>
                ) : (
                  <></>
                )}
                {isAgentLink
                  ? byodAgentList.map((device, i, devices) => (
                    <>
                      <div ref={targetRef}>
                        <DeviceTileMonarch
                          key={device?.id}
                          setIsAddMoreDisabled={setIsAddMoreDisabled}
                          device={device}
                          isFromLearn={isFromLearn}
                          byodList={byodList}
                          handleByodRemove={handleRemove}
                          deviceDetailsModal={deviceDetailsModal}
                          handleDeviceDetailsModal={setDeviceDetailsModal}
                          handleDeviceUpdate={handleDeviceUpdate}
                          handleDeviceUpdateAgent={handleDeviceUpdateAgent}
                          hasDeviceID={device?.hasDeviceID}
                          isMobile={isMobile}
                          pathUrl={pathUrl}
                          showRemove={devices.length > 1}
                          sno={i + 1}
                          deviceList={devices}
                          isPlansFirst={isPlansFirstFlow}
                          selectedDeviceId={selectedDeviceId}
                          handleDeviceId={handleDeviceId}
                          currentDevice={device}
                          showByod={showByod}
                          showByodPage={showByodPage}
                          setShowByod={setShowByod}
                          setShowByodPage={setShowByodPage}
                          setByodDeviceList={setByodDeviceList}
                          setByodAgentDeviceList={setByodAgentDeviceList}
                          showLearnEditPage={showLearnEditPage}
                          setAddMoreDevice={setAddMoreDevice}
                          handleMultiDeviceUpdate={handleMultiDeviceUpdate}
                          isEditPackageFlow={isEditPackageFlow}
                          setIsConnectedDevices={setIsConnectedDevices}
                          isConnectedDevices={isConnectedDevices}
                          setShowLegalDetails={setShowLegalDetails}
                          byodAgentList={byodAgentList}
                          setShowIMEINotificationOuter={setShowIMEINotificationOuter}
                          setShowIncompatibleNotificationOuter={setShowIncompatibleNotificationOuter}
                          checkProtection={checkProtection}
                          setCheckProtection={setCheckProtection}
                          isFeatureError={isFeatureError}
                          setFeatureError={setFeatureError}
                          setShowNotification={setShowNotification}
                        />
                      </div>
                      <MarginSpacerL />
                      {(!addMoreDeviceDisable(deviceList) || isDq) && (i == deviceList.length - 1) && <BtnContainer isMobile={isMobile}>
                        {isPlansFirstNew ||
                          (selected5GPlans && Object.keys(selected5GPlans)?.length > 0) ||
                          (selected4GPlans && Object.keys(selected4GPlans)?.length > 0) ? (
                          <>
                            <Button
                              disabled={false}
                              onClick={onClickShowNotificationbar}
                              size="large"
                              surface="light"
                              use="primary"
                              width={`${isMobile ? '100%' : 'auto'}`}
                              data-track="BYOD:Continue"
                            >
                              Continue
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button
                              disabled={false}
                              onClick={onClickShowNotificationbar}
                              size="large"
                              surface="light"
                              use="primary"
                              width={`${isMobile ? '100%' : 'auto'}`}
                              data-track="Body | Button | Continue to plans"
                            >
                              {t("byod.continueBtn", { ns: "byod" })}
                            </Button>
                          </>
                        )}
                        {deviceList?.length < max_field && showMoreDevices() &&
                          <Button
                            role="button"
                            use="secondary"
                            size="large"
                            surface="light"
                            disabled={addMoreDeviceDisable(deviceList) || isAddMoreDisabled}
                            onClick={checkFlowForModal}
                            width={`${isMobile ? '100%' : 'auto'}`}
                            data-track="Body | Button | Add another device"
                          >
                            {t("byod.byod-collection.addMoreDevices", { ns: "byod" })}
                          </Button>
                        }
                      </BtnContainer>}
                      {!zipCode && (i == deviceList.length - 1) &&
                        <>
                          <MarginSpacerXL />
                          <TextLinkCaret type="standAlone" data-track="Body | Link | Already a Verizon Business customer? Log in" href={aemContentMonarch?.alreadyACustomer?.linkTextUrl}>{aemContentMonarch?.alreadyACustomer?.linkText}</TextLinkCaret>
                        </>}
                    </>
                  ))
                  : deviceList.map((device, i, devices) => (
                    <>
                      <div ref={targetRef}>
                        <DeviceTileMonarch
                          key={device?.id}
                          setIsAddMoreDisabled={setIsAddMoreDisabled}
                          device={device}
                          isFromLearn={isFromLearn}
                          byodList={byodList}
                          handleByodRemove={handleRemove}
                          handleDeviceDetailsModal={setDeviceDetailsModal}
                          handleDeviceUpdate={handleDeviceUpdate}
                          hasDeviceID={device?.hasDeviceID}
                          isMobile={isMobile}
                          pathUrl={pathUrl}
                          showRemove={devices.length > 1}
                          sno={i + 1}
                          deviceList={devices}
                          isPlansFirst={isPlansFirstFlow}
                          selectedDeviceId={selectedDeviceId}
                          handleDeviceId={handleDeviceId}
                          currentDevice={device}
                          showByod={showByod}
                          setShowByod={setShowByod}
                          setByodDeviceList={setByodDeviceList}
                          setByodAgentDeviceList={setByodAgentDeviceList}
                          showLearnEditPage={showLearnEditPage}
                          setAddMoreDevice={setAddMoreDevice}
                          handleMultiDeviceUpdate={handleMultiDeviceUpdate}
                          isEditPackageFlow={isEditPackageFlow}
                          setIsConnectedDevices={setIsConnectedDevices}
                          isConnectedDevices={isConnectedDevices}
                          setShowLegalDetails={setShowLegalDetails}
                          byodAgentList={byodAgentList}
                          setShowIMEINotificationOuter={setShowIMEINotificationOuter}
                          setShowIncompatibleNotificationOuter={setShowIncompatibleNotificationOuter}
                          checkProtection={checkProtection}
                          setCheckProtection={setCheckProtection}
                          isFeatureError={isFeatureError}
                          setFeatureError={setFeatureError}
                          setShowNotification={setShowNotification}
                        />
                      </div>
                      <MarginSpacerL />


                      {(!addMoreDeviceDisable(deviceList) || isDq) && (i == deviceList.length - 1) && <BtnContainer isMobile={isMobile}>
                        {!deviceList?.some(d => d?.isByor) && (isPlansFirstNew ||
                          (selected5GPlans && Object.keys(selected5GPlans)?.length > 0) ||
                          (selected4GPlans && Object.keys(selected4GPlans)?.length > 0)) ? (
                          <>
                            <Button
                              disabled={false}
                              onClick={onClickShowNotificationbar}
                              size="large"
                              surface="light"
                              use="primary"
                              width={`${isMobile ? '100%' : 'auto'}`}
                              data-track="BYOD:Continue"
                            >
                              Continue
                            </Button>
                          </>
                        ) : !deviceList?.some(d => d?.isByor) && (
                          <>
                            <Button
                              disabled={false}
                              onClick={onClickShowNotificationbar}
                              size="large"
                              surface="light"
                              use="primary"
                              width={`${isMobile ? '100%' : 'auto'}`}
                              data-track="Body | Button | Continue to plans"
                            >
                              {t("byod.continueBtn", { ns: "byod" })}
                            </Button>
                          </>
                        )}
                        {deviceList?.length < max_field && showMoreDevices() &&
                          <Button
                            role="button"
                            use="secondary"
                            size="large"
                            surface="light"
                            disabled={addMoreDeviceDisable(deviceList) || isAddMoreDisabled}
                            onClick={checkFlowForModal}
                            width={`${isMobile ? '100%' : 'auto'}`}
                            data-track="Body | Button | Add another device"
                          >
                            {t("byod.byod-collection.addMoreDevices", { ns: "byod" })}
                          </Button>
                        }
                      </BtnContainer>}
                      {(i == deviceList.length - 1) &&
                        <>
                          <MarginSpacerXL />
                          <TextLinkCaret type="standAlone" data-track="Body | Link | Already a Verizon Business customer? Log in" href={aemContentMonarch?.alreadyACustomer?.linkTextUrl}>{aemContentMonarch?.alreadyACustomer?.linkText}</TextLinkCaret>
                        </>}
                    </>
                  ))}
              </ColNoPad>
              <StickyColumn colSizes={{ mobile: 4, tablet: 6, desktop: 4 }}>
                <PromotionCardLayout>
                  <ImageWrapper>
                    <ImageTile
                      background="lightSecondary"
                      borderRadius="tile"
                      contentAlignment="top"
                      dropShadow="none"
                      image={{
                        alt: "Test image",
                        aspectRatio: "1/1",
                        hideBorderOnHover: false,
                        inset: false,
                        position: "top",
                        src: promotionalCardImage(),

                      }}
                      surface="lightPrimary"
                      width={isMobile ? "100%" : "384px"}
                      height={isMobile ? "auto" : "384px"}
                    ></ImageTile>
                  </ImageWrapper>
                  <div
                    style={{
                      height: "auto",
                    }}
                  >
                    <ImageTile
                      background="#EE001E"
                      borderRadius="0px 0px 0.5rem 0.5rem"
                      contentAlignment="top"
                      dropShadow="none"
                      width={isMobile ? "100%" : "384px"}
                      height="225px"
                      surface="lightPrimary"
                      title={{
                        children: <> {promotionalCardTitle()}</>,
                        color: "#ffffff",
                        kind: "title",
                        maxLines: undefined,
                        paddingBottom: undefined,
                        size: "small",
                      }}
                      subtitle={{
                        children: <>{promotionalCardSubTitle()}
                          <MarginSpacerL />
                          <TextLinkWrapper
                            size={isMobile ? "small" : "medium"}
                            type="inline"
                            onClick={handleReadOfferDetails}
                            data-track={`Promo | Read offer details | ${promotionalCardTitle()}`}
                          >
                            {aemContentMonarch?.textLink}
                          </TextLinkWrapper>
                        </>,
                        color: "#ffffff",
                        kind: "body",
                        maxLines: undefined,
                        paddingBottom: undefined,
                        size: "large",

                      }}

                    >

                    </ImageTile>
                  </div>
                  <MarginSpacerL />

                  {showBlackOffer &&
                    <Tileletdiv>
                      <Tilelet
                        title={{
                          size: "titleMedium",
                          children: getBlackOfferContent(),
                          primitive: "h1",
                        }}
                        subtitle={{
                          size: "bodyLarge",
                          color: "#ffffff",
                          children: (
                            <>
                              <MarginSpacerM />
                              <TextLinkWrapperTile
                                size={isMobile ? "small" : "medium"}
                                data-track={`Promo | Read offer details | ${getBlackOfferContent()}`}
                                onClick={handleReadOfferDetailsBlackBanner}
                              >
                                {aemContentMonarch?.textLink}
                              </TextLinkWrapperTile>
                            </>
                          ),
                          type: "standalone",
                          primitive: "h1",
                        }}
                        surface="dark"
                        width={isMobile ? "100%" : "384px"}
                        height={isMobile ? "201px" : "173px"}
                        onClick={() => { }}
                        showBorder={true}
                        backgroundColor="black"
                        innerPadding="24px"
                      />
                    </Tileletdiv>
                  }
                </PromotionCardLayout>
              </StickyColumn>
            </Row>
          </Grid>
        </Suspense>

      </Container>
      {(!isFromLearn && aemContentMonarch?.showPlansOverview) &&
        <PlanSectionContainer>
          <Grid>
            <Row>
              <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                <PlansOverview />
              </Col>
            </Row>
          </Grid>
        </PlanSectionContainer>}
      <Container>
        <Suspense fallback={<></>}>
          <Grid>
            <Row>
              <Col colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                {!!isPDPProtectionEnabled &&
                  ((!!showLegalDetails && featureList?.length) ||
                    protectionAddedOnByod) ? (
                  <>
                    <MarginSpacerL />
                    <ProtectionLegalDetails />
                  </>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Grid>
        </Suspense>
      </Container>
      {removeDevice && (
        <RemoveModalByod
          deviceId={removeDevice}
          showModal={true}
          close={setRemoveDevice}
          removeByodDevice={removeByodDevice}
        />
      )}
      {!showLearnEditPage && removeLearnDevice && (
        <RemoveModalByod
          deviceId={removeLearnDevice}
          showModal={true}
          close={setRemoveLearnDevice}
          removeByodDevice={removeByodLearnDevice}
        />
      )}
      {showMaxDeviceModal && (
        <MaximumDevicesModal
          deviceQuantity={maxDeviceQuantity}
          opened={showMaxDeviceModal}
          onOpenedChange={setMaxDeviceModal}
        />
      )}
      {showNewCustomerModal &&
        (!newAddressModalPopUp ||
          (isPDPProtectionEnabled && isZipcodeOnContinue)) && (
          <NewCustomerModal
            closeBtnClick={setShowNewCustomerModal}
            existingCustomerBtnClicked={existingCustomerBtnClicked}
            newCustomerBtnClicked={newCustomerBtnClicked}
            showNewCustomerModal={showNewCustomerModal}
          />
        )}
      {showNewCustomerModal &&
        newAddressModalPopUp &&
        (!isPDPProtectionEnabled || !isZipcodeOnContinue) && (
          <NewCustomerAddressModal
            pageData={pageData}
            closeBtnClick={setShowNewCustomerModal}
            existingCustomerBtnClicked={existingCustomerBtnClicked}
            newCustomerBtnClicked={newCustomerBtnClicked}
            showNewCustomerModal={showNewCustomerModal}
          />
        )}
      {deviceDetailsModal && (
        <div style={{ height: "763px" }}>
          {deviceList &&
            deviceList.map((device) => (
              <GetDeviceDetailsModal
                device={device}
                pathUrl={pathUrl}
                showModal={true}
                close={setDeviceDetailsModal}
              />
            ))}
        </div>
      )}
      {showDeviceConfirmModal && (
        <PlansFirstDevicesApplyModal
          showModal={true}
          linesCount={plansFirstPageData.linesCount}
          linesRemain={plansFirstPageData.linesRemain}
          selectedQuantity={pageData?.deviceListBy?.length}
          onClickImeifinalizeMultipleSimSelection={
            onClickImeifinalizeMultipleSimSelection
          }
          handleAddMoreDevices={handleAddMoreDevices}
          fromByod={true}
          closeModal={setShowDeviceConfirmModal}
          increaseLinesCount={increaseLinesCount}
        />
      )}
      {globalData?.flow === "plans-first" && (
        <>
          <div style={{ height: "100px" }}></div>
          <PlansFirstContent>
            <Suspense fallback={<></>}>
              <GridwallPlansFirstDevices
                selectedProducts={pageData?.plansFirstDevices}
                linesCount={plansFirstPageData.linesCount}
                linesRemain={plansFirstPageData.linesRemain}
              />
            </Suspense>
          </PlansFirstContent>
        </>
      )}
      <Modal
        width="560px"
        maxHeight="696px"
        ariaLabel="disconnect modal"
        opened={readOfferModal}
        onOpenedChange={setReadOfferModal}
        surface="light"
        fullScreenDialog={false}
        className={readOfferModal ? 'Modal is-active': ''}
      >
        <h1 style={{display:"none"}}>{promotionalCardTitle()}</h1>
        <iframe
          height="696px"
          style={{ border: "none", backgroundColor: "white" }}
          width={isMobile ? "100%" : "560px"}
          src={
            pathUrl?.includes('tablets') ? aemContentMonarch?.promotionalCard?.tablets?.offerdetails
              : pathUrl?.includes('laptops') ? aemContentMonarch?.promotionalCard?.laptops?.offerdetails
                : aemContentMonarch?.promotionalCard?.smartPhones?.offerdetails
          }
        ></iframe>
      </Modal>

      <Modal
        minHeight="696px"
        width="560px"
        ariaLabel="OfferDetailmodal"
        opened={readOfferModalBlackBanner}
        onOpenedChange={setReadOfferModalBlackBanner}
        surface="light"
        fullScreenDialog={false}
        className={readOfferModalBlackBanner ? 'Modal is-active': ''}
      >
        <OfferModal>
          <MarginSpacerM />
          <h1 style={{display:"none"}}>{getBlackOfferContent()}</h1>
          <TitleLockup><TitleLockupTitle size={"titleMedium"} bold={true}>
            {pathUrl?.includes('tablets') ? 'Laptops' :
              pathUrl?.includes('laptops') ? 'Tablets' :
                'Tablets'}</TitleLockupTitle></TitleLockup>
          <MarginSpacerM />
          <iframe
            style={{ border: "none", backgroundColor: "white" }}
            height={isMobile ? "550px" : "440px"}
            width={isMobile ? "100%" : "560px"}
            src={
              pathUrl?.includes('tablets') ? aemContentMonarch?.promotionalCard?.laptops?.offerdetails :
                pathUrl?.includes('laptops') ? aemContentMonarch?.promotionalCard?.tablets?.offerdetails :
                  aemContentMonarch?.promotionalCard?.tablets?.offerdetails
            }
          ></iframe>
          <MarginSpacerM />
          <TitleLockup><TitleLockupTitle size={"titleMedium"} bold={true}>
            {pathUrl?.includes('tablets') ? 'Smartphones' :
              pathUrl?.includes('laptops') ? 'Smartphones' :
                'Laptops'}</TitleLockupTitle></TitleLockup>
          <MarginSpacerM />
          <iframe
            style={{ border: "none", backgroundColor: "white" }}
            height={isMobile ? "550px" : "440px"}
            width={isMobile ? "100%" : "560px"}
            src={
              pathUrl?.includes('tablets') ? aemContentMonarch?.promotionalCard?.smartPhones?.offerdetails :
                pathUrl?.includes('laptops') ? aemContentMonarch?.promotionalCard?.smartPhones?.offerdetails :
                  aemContentMonarch?.promotionalCard?.laptops?.offerdetails
            }
          ></iframe>
        </OfferModal>
      </Modal>
    </>
  );
};

const BtnContainer = styled.div`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? "column" : "row")};
  gap: 12px;
`;
const Container = styled.div`
  margin: 24px;
  margin-top: 24px;
  width: ${({ isMobile }) => (isMobile && "100%")};
  @media only screen and (max-width: 767px) {
    margin: 0rem;
    margin-bottom: 1rem;
  }
`;
const PlanSectionContainer = styled.div`
  background: #f8f3e9;
  height: 939px;
  padding-top: 64px;
  
    @media (max-width: 767px) {
    padding-top: 24px;
  }`;

const TextLinkWrapper = styled(TextLink)`
align-item:start;
// >a{
// }.hHhLAC:hover{
// color:#ffffff;
// }
// }
// color:#ffffff;
`
const PlansFirstContent = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 99;
  background: white;
  width: 100vw;
  border-top: 1px solid #d8dada;
  @media only screen and (max-width: 800px) {
    .h5 {
      margin-left: 1rem;
    }
  }
`;

const StyledCol = styled(Col)`
  padding-left: 0;
  padding-right: 0;
  width: auto;
  flex-basis: auto;
  padding-right: ${({ lastIndex }) => (lastIndex ? "" : "32px")};
  @media only screen and (max-width: 767px) {
    margin-bottom: 16px !important;
    padding-right: 0 !important; 
    flex-basis: 100%; 
    text-align: center; 
  }
`;
const StyledDiv = styled.div`
  background-color: #ff0000;
  border-radius: 0px 0px 0.5rem 0.5rem;
  width: 384px;
  height: 225px;
  padding: 24px;
  @media only screen and (max-width:767px){
  width:328px;
  }
`;

const ImageWrapper = styled.div`
[class^="VBG__DS__image-tile-module__22bnt"]{
padding:0px;}
`;

const StickyColumn = styled(Col)`
  @media only screen and (min-width: 768px) {
    position: sticky;
    padding-left:2.5rem;
    top: 120px; /* Adjust based on header height */
    align-self: flex-start;
    height: fit-content;
  }
`;

const PromotionCardLayout = styled.div`
margin:0px;
padding:0px;
@media only screen and (max-width:768px){
        min-width: 100%;
        padding-top:16px;
        padding-bottom: 32px;
  ;}
  `;

const TextLinkWrapperTile = styled(TextLink)`
&:hover{
      color:#ffffff;
      text-decoration:underline;
      text-underline-offset: 2px;
}
`;

const TitleLockupTitleDiv = styled.div`
margin-left:-10px;
@media only screen and (max-width:768px){
       margin-left:8px;
        
  ;}
`;

const OfferModal = styled.div`
display:flex;
flex-direction: column;
padding:0px;
margin:0px;
`;

const Tileletdiv = styled.div`
 @media only screen and (max-width: 767px) {
>div>div>div>div{
padding:24px;
}
}

`;


export default ByodMonarch;
